/**
 * @flow
 * @relayHash 237a6282377ba3590ae8fffd8e479fb5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AcceptanceReportPageCsvQueryVariables = {||};
export type AcceptanceReportPageCsvQueryResponse = {|
  +blocSystemDocumentTemplatesAcceptanceCsv: ?{|
    +taskId: ?string
  |}
|};
export type AcceptanceReportPageCsvQuery = {|
  variables: AcceptanceReportPageCsvQueryVariables,
  response: AcceptanceReportPageCsvQueryResponse,
|};
*/


/*
query AcceptanceReportPageCsvQuery {
  blocSystemDocumentTemplatesAcceptanceCsv {
    taskId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "blocSystemDocumentTemplatesAcceptanceCsv",
    "storageKey": null,
    "args": null,
    "concreteType": "CSVTaskResult",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "taskId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "AcceptanceReportPageCsvQuery",
  "id": "199363851c40032948d26aaf9f21fc6d",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "AcceptanceReportPageCsvQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v0
  },
  "operation": {
    "kind": "Operation",
    "name": "AcceptanceReportPageCsvQuery",
    "argumentDefinitions": [],
    "selections": v0
  }
};
})();
node.text = "query AcceptanceReportPageCsvQuery {\n  blocSystemDocumentTemplatesAcceptanceCsv {\n    taskId\n  }\n}\n";
(node/*: any*/).hash = '3b132596a782710e8af33a15f775788d';
module.exports = node;
